import React, { Component } from "react";
import PropTypes from "prop-types";
import style from "./History.module.scss";
import { Modal, ModalHeader, ModalBody, ModalFooter, Container, Button } from "reactstrap";
import { FormattedDate, FormattedTime } from "react-intl";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
import { CircularProgress } from "../..";
import { localDateTime } from "../../../utils/Helper";

class HistoryDefault extends Component {
  constructor(props) {
    super(props);
    this.state = {
      histories: null,
      loading: true,
    };
    
    const { process, processCharId, processId } = props || {};
    if (process || processCharId || processId) {
      this.props.onHistoryRequest({ process, processCharId, processId }).then((response) => {
        this.setState({
          loading: false,
          histories: response.response.histories,
        });
      });
    }
  }

  componentWillReceiveProps(nextProps, nextState) {
    const { processId, process } = nextProps;
    if (processId && !this.state.histories) {
      this.props.onHistoryRequest({ process, processId }).then((response) => {
        this.setState({
          loading: false,
          histories: response.response.histories,
        });
      });
    }
  }

  toggle = () => {
    this.props.onToggle();
    this.setState({ histories: null, loading: true });
  };

  render() {
    const { process, open } = this.props;

    if (!open) {
      return null;
    }

    return (
      <div>
        <Modal isOpen={this.props.open} toggle={this.toggle} className={style.modal}>
          <ModalHeader toggle={this.toggle}>{process} history</ModalHeader>
          <ModalBody style={{ padding: "10px 2px" }}>
            <Container>
              <h5 className={style.subtitle}>History</h5>
              {this.state.loading ? (
                <CircularProgress />
              ) : (
                <div className={style.histories}>
                  {this.state.histories.length == 0 && (
                    <span className="text-center mt-3 mb-3 d-block">Empty history</span>
                  )}
                  {this.state.histories.map((item) => (
                    <div className={style.item} key={`h-${item.HistoryId}`}>
                      <div className={style.header}>
                        <span className={style.user}>{item.HistoryUserName}</span>

                        <span color="secondary" className={style.time}>
                          <FormattedDate value={localDateTime(item.HistoryDateTime)} />{" "}
                          <FormattedTime value={localDateTime(item.HistoryDateTime)} hour12={false} />
                        </span>
                      </div>

                      <p>
                        {item.HistoryDetails.trim()
                          .split("\\n")
                          .map((line, index) => (
                            <React.Fragment key={index}>
                              {line}
                              <br />
                            </React.Fragment>
                          ))}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </Container>
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={this.toggle}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default HistoryDefault;
